<div class="header">
  <div class="left">
    <img src="assets/logo.png" class="logo">
    @if ((auth.loggedIn | async) && !isSurveyAnswerPage) {
      <nav class="header-nav">
        <a class="menu-large"
           [routerLink]="['/myevent']"
           routerLinkActive="active">
          <div>MYイベント</div>
        </a>

        <a class="menu-large"
           [routerLink]="['/event-search']"
           routerLinkActive="active">
          <div>イベント検索</div>
        </a>

        <a class="menu-large"
           [routerLink]="['/union-consultation']"
           routerLinkActive="active">
          <div>組合相談</div>
        </a>

        <a class="menu-large"
           [routerLink]="['/survey']"
           routerLinkActive="active">
          <div>90秒アンケート</div>
        </a>
      </nav>
    }
  </div>

  <div class="right">
    @if (!isSurveyAnswerPage) {
      @if (!(auth.loggedIn | async)) {
        <button
        mat-button
        class="name-btn dummy"
        [class.auth-entry]="isAuthEntryPage"
        disabled
      >
        {{ companyName$ | async }}
      </button>
      }

      @if ((auth.loggedIn | async)) {
        <button
        mat-button
        class="name-btn"
        [matMenuTriggerFor]="menu"
      >
        {{ companyName$ | async }}
        <mat-icon iconPositionEnd>keyboard_arrow_down</mat-icon>
      </button>
          <mat-menu #menu="matMenu" xPosition="before" class="header-menu-dropdown">
            @if (auth.hasAuth(2)) {
              <button mat-menu-item (click)="onOrganizationAccount()">アカウント管理</button>
            }
            @if (auth.hasAuth(1)) {
              <button mat-menu-item (click)="onOrganizationAbout()">組織情報</button>
              <button mat-menu-item (click)="onMasterSettings()">マスタ設定</button>
            }
            <button mat-menu-item (click)="onAccountAbout()">個人設定</button>
            <button mat-menu-item (click)="onLogout()">ログアウト</button>
          </mat-menu>

        <!-- SP（767px以下）用：組織名とメニュー（MYイベント〜90秒アンケート）をハンバーガーの中にまとめる -->
        <button mat-icon-button class="hamburger-btn" [matMenuTriggerFor]="spMenu" aria-label="メニューを開く">
          <mat-icon>menu</mat-icon>
        </button>
        <mat-menu #spMenu="matMenu" xPosition="before" class="header-menu-dropdown header-sp-menu">
          <div class="sp-menu-company" [style.font-size.px]="spCompanyFontSize">{{ companyName$ | async }}</div>
          <button mat-menu-item [routerLink]="['/myevent']">MYイベント</button>
          <button mat-menu-item [routerLink]="['/event-search']">イベント検索</button>
          <button mat-menu-item [routerLink]="['/union-consultation']">組合相談</button>
          <button mat-menu-item [routerLink]="['/survey']">90秒アンケート</button>
          @if (auth.hasAuth(2)) {
            <button mat-menu-item (click)="onOrganizationAccount()">アカウント管理</button>
          }
          @if (auth.hasAuth(1)) {
            <button mat-menu-item (click)="onOrganizationAbout()">組織情報</button>
            <button mat-menu-item (click)="onMasterSettings()">マスタ設定</button>
          }
          <button mat-menu-item (click)="onAccountAbout()">個人設定</button>
          <button mat-menu-item (click)="onLogout()">ログアウト</button>
        </mat-menu>
      }
    }
  </div>
</div>
